import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const MailIcon = (props) => {
  const {fill = 'none', stroke = '#fff' } = props;
  
  return (
    <SvgIcon className="icon" {...props} style={{fill, stroke, strokeWidth: '2px'}} viewBox="0 0 20.774 16">
      <path className="a"
            d="M3,8l7.891,5.26a2,2,0,0,0,2.219,0L21,8M5,19H19a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H5A2,2,0,0,0,3,7V17A2,2,0,0,0,5,19Z"
            transform="translate(-1.613 -4)"/>
    </SvgIcon>
  );
};

export default MailIcon;